export class RegistrazioneStudenteRequest {
  nome?: string;
  cognome?: string;
  email?: string;
  password?: string;
  dataNascita?: string;
  // valutazioneMaterie: Array<ValutazioneMateria>;
  photoUrl?: string;
  token?: string;
  classeId?: string;
  sesso?: boolean;
  indicatoreSocioDemografico?: IndicatoreSocioDemografico ;

  constructor() {
    // this.valutazioneMaterie = [];
  }
}

export interface ValutazioneMateria {
  materiaId: string;
  valore: number;
}

export interface IndicatoreSocioDemografico {
  frequenzaItaliano: number;
  quantitaLibri: number;
  postoTranquillo: boolean;
  computer: boolean;
  internet: boolean;
  camera: boolean;
}